import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(({ palette, spacing, breakpoints, variables }) =>
  createStyles({
    "@global": {
      ['div[role=presentation]']: {
        top: '72px !important',
        '& .errorBackdrop':{
          top:'72px !important'
        }
      },
    },
    title:{
      marginBottom:variables?.spacingE
    },
    actionButton:{
      float:'right',
      ['@media only screen and (max-width:1024px)']: {
        width: '100%',
      },
    },
    imageContainer:{
      textAlign:'center'
    },
    paper: {
      outline: 'none',
      width: 450,
      backgroundColor: palette.jet?.containerDefault,
      padding: variables?.spacingE,
      ['@media only screen and (max-width:500px)']: {
        width: '100%',
        left: 'calc(48% - 43%)'
      },
      '& button': {
        height: '56px',
        textTransform: 'none'
      },
      '& img': {
        marginTop: '10px',
        marginBottom: '10px'
      }
    },
  }),
);

// left: calc(50% - 43%);
export default useStyles